<template>
  <DsChecklistSection
    title-id="preventa-pending-property-title"
    title-base="Si aún no tienes"
    title-highlight="inmueble definido"
    subtitle="Tienes hasta 90 días después de contratar para compartir la información del inmueble"
    items-title="Documentación requerida"
    :icon-src="pendingPropertyIcon"
    :check-icon-src="checkIcon"
    :items="items"
  >
    <template #after-items>
      <aside class="preventa-pending-property__tooltip">
        <header class="preventa-pending-property__tooltip-header">
          <img
            :src="lightbulbIcon"
            alt=""
            aria-hidden="true"
            class="preventa-pending-property__tooltip-icon"
          >

          <DsText as="subtitle8" class="preventa-pending-property__tooltip-title">
            Si no entregas la documentación
          </DsText>
        </header>

        <ul class="preventa-pending-property__tooltip-list">
          <li>Deberás comenzar a pagar mensualidades</li>
          <li>Tu cuenta puede entrar a proceso de cobranza.</li>
        </ul>
      </aside>
    </template>
  </DsChecklistSection>
</template>

<script setup lang="ts">
import pendingPropertyIcon from '../../../../../assets/preventa/block_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24 1.svg'
import checkIcon from '../../../../../assets/preventa/Layer_1.svg'
import lightbulbIcon from '../../../../../assets/preventa/lightbulb_circle_24dp_1F1F1F_FILL1_wght400_GRAD0_opsz24 1.svg'
import DsText from '../atoms/DsText.vue'
import DsChecklistSection from '../components/DsChecklistSection.vue'

const items = [
  {
    id: 'purchase-agreement',
    text: 'Contrato de compraventa'
  },
  {
    id: 'developer-letter',
    text: 'Carta del desarrollo con el inmueble elegido'
  },
  {
    id: 'developer-contact',
    text: 'Contacto del desarrollador'
  }
]
</script>

<style scoped>
.preventa-pending-property__tooltip {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.preventa-pending-property__tooltip-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.preventa-pending-property__tooltip-icon {
  display: block;
  flex: 0 0 24px;
  width: 24px;
  height: 24px;
}

.preventa-pending-property__tooltip-title {
  color: var(--ds-text-primary);
  line-height: 20px;
}

.preventa-pending-property__tooltip-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 0;
  padding-left: 24px;
  color: var(--ds-text-primary);
  font-family: var(--ds-font-family-base);
  font-size: var(--ds-body4-size);
  font-weight: var(--ds-body4-weight);
  line-height: 20px;
}

@media (min-width: 1208px) {
  .preventa-pending-property__tooltip {
    display: none;
  }
}
</style>
